export function numToThaiBaht(number: number): string { 
    if (typeof number !== 'number') {
        throw new TypeError("Input must be a number.");
    }

    const integerPart = Math.floor(number);
    const decimalPart = Math.round((number - integerPart) * 100);

    const thaiNumbers: Record<number, string> = { 
        0: "ศูนย์", 1: "หนึ่ง", 2: "สอง", 3: "สาม", 4: "สี่",
        5: "ห้า", 6: "หก", 7: "เจ็ด", 8: "แปด", 9: "เก้า"
    };

    const thaiUnits: Record<number, string> = { 
        0: "", 1: "สิบ", 2: "ร้อย", 3: "พัน", 4: "หมื่น",
        5: "แสน", 6: "ล้าน"
    };

    function _convertSegment(nStr: string): string { 
        if (!nStr) {
            return "";
        }

        const length = nStr.length;
        let result: string[] = []; 
        for (let i = 0; i < length; i++) {
            const digit = parseInt(nStr[i]);
            const unitIndex = (length - 1 - i) % 6;

            if (digit === 0) {
                if (length === 1 && i === 0) {
                    result.push(thaiNumbers[0]);
                }
                continue;
            }

            if (unitIndex === 1) {
                if (digit === 1) {
                    result.push("สิบ");
                } else if (digit === 2) {
                    result.push("ยี่สิบ");
                } else {
                    result.push(thaiNumbers[digit] + thaiUnits[unitIndex]);
                }
            } else if (unitIndex === 0 && digit === 1 && i !== length - 1 && parseInt(nStr[i - 1]) !== 0) {
                result.push("เอ็ด");
            } else {
                result.push(thaiNumbers[digit] + thaiUnits[unitIndex]);
            }
        }
        return result.join("");
    }

    function _convertLargeNumber(n: number): string { 
        if (n === 0) {
            return thaiNumbers[0];
        }

        let nStr = String(n);
        let parts: string[] = []; // เพิ่ม type
        let hasNonZeroSegment = false;

        while (nStr.length > 0) {
            let segment = nStr.slice(-6);
            nStr = nStr.slice(0, -6);
            
            let segmentVal = parseInt(segment);
            if (segmentVal > 0) {
                let segmentText = _convertSegment(String(segmentVal));
                parts.unshift(segmentText);
                hasNonZeroSegment = true;
            } else {
                if (hasNonZeroSegment && parts.length > 0 && !parts[0].includes("ล้าน")) {
                }
            }
            
            if (nStr.length > 0 && hasNonZeroSegment) {
                if (parts.length > 0 && !parts[0].includes("ล้าน")) {
                    parts.unshift("ล้าน");
                }
            }
        }

        let finalResultParts: string[] = [];
        let tempSegments: string[] = [];
        let originalNumStr = String(n);
        
        while (originalNumStr.length > 0) {
            let segment = originalNumStr.slice(-6);
            originalNumStr = originalNumStr.slice(0, -6);
            tempSegments.unshift(segment);
        }

        for (let i = 0; i < tempSegments.length; i++) {
            const segment = tempSegments[i];
            const segmentVal = parseInt(segment);

            if (segmentVal > 0) {
                finalResultParts.push(_convertSegment(String(segmentVal)));
            }
            
            if (i < tempSegments.length - 1) {
                if (segmentVal > 0 || (i > 0 && parseInt(tempSegments[i-1]) > 0)) {
                    finalResultParts.push("ล้าน");
                }
            }
        }

        
        let cleanedResult: string[] = [];
        for (let i = 0; i < finalResultParts.length; i++) {
            if (finalResultParts[i] === "ล้าน" && (i === 0 || cleanedResult[cleanedResult.length - 1] === "ล้าน")) {
                continue; 
            }
            cleanedResult.push(finalResultParts[i]);
        }
        
        let partsArr: string[] = [];
        let strN = String(n);
        let millionCounter = 0;

        while (strN.length > 0) {
            let segment = strN.slice(-6);
            strN = strN.slice(0, -6);
            
            let segmentVal = parseInt(segment);
            if (segmentVal > 0) {
                let segmentText = _convertSegment(String(segmentVal));
                if (millionCounter > 0) {
                    segmentText += "ล้าน".repeat(millionCounter);
                }
                partsArr.unshift(segmentText);
            } else if (millionCounter > 0 && strN.length > 0 && partsArr.length > 0 && !partsArr[0].includes("ล้าน")) {
                partsArr.unshift("ล้าน".repeat(millionCounter));
            }
            millionCounter++;
        }
        
        let finalCleanedParts: string[] = [];
        let lastPartWasMillion = false;
        for (const part of partsArr) {
            if (part.includes("ล้าน")) {
                if (!lastPartWasMillion) {
                    finalCleanedParts.push(part);
                    lastPartWasMillion = true;
                }
            } else {
                finalCleanedParts.push(part);
                lastPartWasMillion = false;
            }
        }
        return finalCleanedParts.join("");
    }

    let bahtText = _convertLargeNumber(integerPart);
    if (bahtText === thaiNumbers[0]) {
        bahtText = "";
    }

    if (integerPart === 0 && decimalPart === 0) {
        return "ศูนย์บาทถ้วน";
    }

    let result = `${bahtText}บาท`;

    if (decimalPart > 0) {
        if (decimalPart === 100) {
            result = `${_convertLargeNumber(integerPart + 1)}บาทถ้วน`;
        } else {
            const satangStr = String(decimalPart).padStart(2, '0');
            const satangText = _convertSegment(satangStr);
            if (satangText === thaiNumbers[0]) {
                result += "ถ้วน";
            } else {
                result += `${satangText}สตางค์`;
            }
        }
    } else {
        result += "ถ้วน";
    }

    return result;
}